import React, { useState } from "react";

import { exitImpersonation } from "services";

import { bailOutOfImpersonation, useUserContext } from "utils";

import { AlertBanner, Button, Flex, Typography } from "components";

export const ImpersonationBanner = () => {
  const { user } = useUserContext();
  const active = !!user?.impersonation;

  const [exiting, setExiting] = useState(false);

  if (!active) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitImpersonation();
    } catch {
      // best effort, leave regardless so the admin is never stuck in the farmer app
    }
    await bailOutOfImpersonation({ closeTab: true });
  };

  return (
    <div className="impersonation-banner-wrapper">
      <AlertBanner
        type="warning"
        className="impersonation-compact"
        gap={4}
        description={
          <Flex align="center" gap={12} wrap="wrap">
            <Typography variant="paragraph-s" className="margin-0">
              You are viewing this account as an admin.
            </Typography>
            <Button type="secondary" size="small" loading={exiting} onClick={handleExit}>
              Exit
            </Button>
          </Flex>
        }
      />
    </div>
  );
};

export default ImpersonationBanner;
